import { render, staticRenderFns } from "./detailHistoricEdition.vue?vue&type=template&id=29881ca1&scoped=true&"
import script from "./detailHistoricEdition.vue?vue&type=script&lang=js&"
export * from "./detailHistoricEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29881ca1",
  null
  
)

export default component.exports